import {defineStore} from "pinia";
import {useICPStore} from "@/stores/icpStore";
import {useAuthStore} from "@/stores/authStores";
import api from "@/services/api";


export const useContactsStore = defineStore('contactsStore', {
    state: () => ({
        trains: [],
        handheld: [],
        selectedTrains: [],
        selectedHandheld: [],
        selectedPhoneContacts: [],
    }),

    getters: {
        // return an array like [{ISDN: 123}, {ISDN: 456}, ...] needed by sdk to subscribe to status changes
        getIsdnArray: state => {
            var array = [];
            state.handheld.forEach(item => {
                array.push({isdn: item.isdn});
            });
            return array;
        },
        getOnlineTrains: state => {
            return state.trains.filter(train => train.status === 'Online');
        },
        getOnlineHandHeld: state => {
            return state.handheld.filter(hh => hh.status === 'Online');
        },
        getAllSelected: state => {
            return [
                ...state.selectedTrains,
                ...state.selectedHandheld
            ];
        }
    },

    actions: {
        updateContactsStatus(data) {
            data.forEach((item) => {
                if (item.statustype === '15' || item.statustype === '16') {
                    // update handheld status
                    const handheld = this.handheld.find(handheld => handheld.isdn === item.isdn);
                    if (handheld) {
                        handheld.status = item.statusvalue === '4011' ? 'Online' : 'Offline';
                        if (handheld.status === 'Offline') {
                            const index = this.selectedHandheld.findIndex(hh => hh.value.isdn === handheld.isdn);
                            if (index !== -1) {
                                // remove from selectedHandheld if it was selected
                                this.selectedHandheld.splice(index, 1);
                            }
                        }
                    }

                }
            })
        },

        setNetworkContacts(data) {
            if (data.list) {
                this.handheld = data.list
                    .filter(item => item.isdn !== useAuthStore().loggedUser)
                    .filter(item => item.category === '9')
                    .map(item => ({
                        radioId: item.name,
                        isdn: item.isdn,
                        status: "Unknown"
                    }));

                useICPStore().ICP.dispatch.voice.subscribeUserStatus({
                    reslist: this.getIsdnArray,
                    callback: () => {
                    }
                });
            }
        },

        fetchTrainsList() {
            api.get('/train/getOnlineTrains', {
                params: {
                    loggedUsername: useAuthStore().loggedUser
                }
            })
                .then(response => {
                    this.trains = response.data;
                    // Filter out selected trains that are not online
                    this.selectedTrains = this.selectedTrains.filter(train =>
                        this.trains.some(t => t.trainId === train.value.trainId)
                    );
                })
                .catch(error => {
                    console.error("There was an error fetching online trains: ", error);
                });
        }

    }
})

